<template>
  <div>
    <right-panel :id="`sidebar-create-task-` + stage" width="800px" :icon="'mdi mdi-plus'" :text="$t('task.create')" @hidden="onHidden">
      <div class="pl-5 pr-5">
        <h6 class="mt-4">{{ $t("task.category") }}</h6>
        <filter-select
          :validation="true"
          :isValid="!$v.form.category.$invalid"
          id="textCategoryFilter"
          ref="textCategoryFilter"
          :placeholder="$t('task.category')"
          :multiple="false"
          @filter="onCategorySearch"
          :selected="form.category"
          @changed="onCategorySelect"
        />

        <br />
        <sweet-input
          v-model="form.name"
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          layout="vertical"
          :placeholder="$t('common.name')"
          :label="$t('task.summary')"
        />
        <br />

        <sweet-textarea
          v-model="form.description"
          :isValid="!$v.form.description.$error"
          @input="$v.form.description.$touch()"
          type="text"
          layout="vertical"
          :placeholder="$t('common.description')"
          :label="$t('process.description')"
          :rows="3"
        />

        <h6 class="mt-4">{{ $t("task.blocked-by") }}</h6>
        <filter-select
          id="taskFilter"
          ref="taskFilter"
          :placeholder="$t('task.summary')"
          :multiple="true"
          @filter="onTaskSearch"
          :selected="form.blockedByTasks"
          @changed="onBlockedByTasksSelect"
        />

        <sweet-button @click="ok()" :disabled="$v.$invalid" type="submit" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>
      </div>
    </right-panel>
  </div>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";

export default {
  props: ["stage", "store"],
  components: { SweetTextarea },
  data() {
    return {
      selectedCompliancePolicy: undefined,
      form: {
        name: undefined,
        description: undefined,
        relatedQuestionSet: undefined,
        blockedByTasks: undefined,
        category: undefined,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      description: {
        required,
      },

      category: {
        required,
      },
    },
  },
  computed: {
    tasks() {
      return this.$store.getters[`${this.store}/tasks`].filter((i) => i.stage == this.stage);
    },
    editedTask() {
      return this.$store.getters[`${this.store}/editedTask`];
    },
  },
  watch: {
    editedTask: {
      deep: true,
      immediate: true,
      handler(v) {
        this.$refs?.taskFilter?.reset();
        this.form = {};
        if (!v) {
          return;
        }
        const blockedByTasks = v.blockedByTasks?.map((i) => ({ _id: i._id, name: i.name })) ?? [];
        this.selectedCompliancePolicy = v.relatedQuestionSet?.value;
        this.form = { ...this.prepareFormForEdit(v), blockedByTasks };
      },
    },
  },
  methods: {
    onHidden() {
      this.form = {};
      this.$store.commit(`${this.store}/editedTask`, undefined);
    },

    onTaskSearch(value, callback) {
      let response = this.tasks?.map((i) => ({ _id: i._id, name: i.name }));

      if (this.editedTask) {
        response = response.filter((i) => i._id != this.editedTask._id);
      }
      callback(response ?? []);
    },
    onBlockedByTasksSelect(items) {
      this.form = { ...this.form, blockedByTasks: [...items] };
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`managementTaskCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, "scope.value": { value: "system", isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item };
    },

    async onCompliancePolicySearch(value, callback) {
      const response = await this.$store.dispatch(`managementCompliancePolicy/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, "scope.value": { value: "system", isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },
    onCompliancePolicySelect(item) {
      this.selectedCompliancePolicy = item;
      this.form = { ...this.form, relatedQuestionSet: { type: "COMPLIANCE_POLICY", value: { _id: item._id, name: item.name } } };
    },

    ok() {
      const payload = {
        _id: this.form._id,
        name: {
          [this.currentLanguage]: this.form.name,
        },
        description: {
          [this.currentLanguage]: this.form.description,
        },
        category: this.form.category,
        blockedByTasks: this.form.blockedByTasks,
        relatedQuestionSet: this.form.relatedQuestionSet,
        stage: this.stage,
      };

      if (this.editedTask) {
        this.$store.commit(`${this.store}/updateTaskItemsToStage`, { task: payload });
      } else {
        this.$store.commit(`${this.store}/addTaskItemsToStage`, { task: payload });
      }

      this.form = {};
      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task-` + this.stage);
    },
  },
};
</script>
